export default (type) => {
  const hideKeys = ['account_type', 'category', 'inside_type'];
  const list = [
    {
      label: '消耗',
      prop: 'cost_total',
    },
    // {
    //   label: '请求数',
    //   prop: 'request',
    // },
    // {
    //   label: '有效请求数',
    //   prop: 'served_request',
    // },
    // {
    //   label: '填充率',
    //   prop: 'filled_rate',
    // },
    {
      label: '展示数',
      prop: 'impression_total',
    },
    {
      label: '点击数',
      prop: 'click_total',
    },
    {
      label: 'CTR',
      prop: 'ctr',
    },
    {
      label: 'ECPM',
      prop: 'ecpm',
    },
    {
      label: 'ACP',
      prop: 'acp',
    },
    {
      label: '有消耗账户数',
      prop: 'served_account_num',
      width: '100px',
    },
  ];

  if (hideKeys.includes(type)) {
    return list.filter(
      (item) => item.prop !== 'request' && item.prop !== 'filled_rate',
    );
  }

  return list;
};
